import React from 'react';
import Radium from 'radium';

export class Button extends React.Component {

  render() {

    const buttonStyle = {

      background: '#BE1C03',
      color: 'white',
      width: '100%',
      margin: '10px auto 0px 0px', //t,r,b,l
      fontSize: '20px',

      // npm radium dependency
      ':hover': {
        background: 'black',
        color: 'BE1C03',
        border: '1px solid green'
      },
      '@media (max-width: 992px)': {
        width: '100%',
      },
      padding: '10px',
      textTransform: 'uppercase',
      textAlign: 'center'
    };

    return (

      <div className="pbutton">
        <style>
          {`@media print {.pbutton{display: none;}}`}
        </style>

        <button style={buttonStyle} onClick={this.props.onClick}><span>{this.props.buttontext}</span></button>
      </div>

    )
  }
}

Button = Radium(Button);
export default Button;